import { TaxonomyPage } from '@zoopla/tracking';

export const getSegmentPage = (pathname: string) => {
    // This removes the dynamic path on pathname, e.g. `/new-homes/details/[listingId]`, it removes `[listingId]`
    const currentPath = pathname.replace(/(\/\[.+\]$)/, '');

    const keyMap: Record<string, TaxonomyPage> = {
        '/': '/homepage/',
        '/home-values': '/home-values/',
        '/valuation': '/valuation/',
        '/privacy': '/privacy/',
        '/discover': '/discover/',
        '/for-sale': '/for-sale/results/',
        '/for-sale/details': '/for-sale/details/',
        '/to-rent': '/to-rent/results/',
        '/to-rent/details': '/to-rent/details/',
        '/new-homes': '/new-homes/results/',
        '/new-homes/details': '/new-homes/details/',
        '/property': '/property/uprn/',
        '/signin': '/signin/',
        '/register': '/register/',
        '/myaccount/my-home/uprn/': '/myaccount/my-home/',
        '/house-prices': '/house-prices/results/',
        '/my-home/select/': '/my-home/select/',
        '/agent-matcher': '/agent-matcher/'
    };

    const page = keyMap[currentPath]
        ? keyMap[currentPath]
        : ('/homepage/' as const);

    return page;
};
